import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../Pages/Login';
import Home from '../Pages/Home';
import ProtectedRoute from './ProtectedRoute';
import Navbar from '../Components/Navbar';
import Collages from '../Pages/Collage';
import JobDrives from '../Pages/JobDrives';
import CollageDetailed from '../Pages/CollageDetailed';
import Students from '../Pages/Students';
import StudentDetailed from '../Pages/StudentDetailed';
import Reports from '../Pages/Reports';
import Applications from '../Pages/Applications';
import ForcePasswordChange from '../Pages/ForcePasswordChange';
const Pageroutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/force-password-change" element={<ForcePasswordChange />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
                <Route
                    path="*"
                    element={
                        <>
                            <Navbar />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/job-drives" element={<JobDrives />} />
                                <Route path="/applications" element={<Applications />} />
                                <Route path="/reports" element={<Reports />} />
                                <Route path="/college-details" element={<Collages />} />
                                <Route path="/college-details/detailed" element={<CollageDetailed />} />
                                <Route path="/students-data" element={<Students />} />
                                <Route path="/admin/students/detailed-student" element={<StudentDetailed />} />
                                <Route path="/teacher/students/detailed-student" element={<StudentDetailed />} />
                                <Route path="/placement/students/detailed-student" element={<StudentDetailed />} />
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </>
                    }
                />
            </Route>
        </Routes>
    );
};

export default Pageroutes;
